// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3ICoa","inputWrap":"Table_inputWrap__3VwZq","col":"Table_col__U_U55","bmiTooltip":"Table_bmiTooltip__1T9b7"};